// extracted by mini-css-extract-plugin
export var spin = "title-module--spin--05128";
export var title = "title-module--title--854a7";
export var title__black = "title-module--title__black--cc8ce";
export var title__bloodorange = "title-module--title__bloodorange--9d4b7";
export var title__chartruse = "title-module--title__chartruse--adfc4";
export var title__cobalt = "title-module--title__cobalt--15cf1";
export var title__dark = "title-module--title__dark--afeef";
export var title__emerald = "title-module--title__emerald--f5fb7";
export var title__paper = "title-module--title__paper--0f50b";
export var title__pink = "title-module--title__pink--7f83e";
export var title__sky = "title-module--title__sky--46d6f";
export var title__white = "title-module--title__white--6750d";
export var wrapper = "title-module--wrapper--d3cf3";
export var wrapper__black = "title-module--wrapper__black--3b889";
export var wrapper__bloodorange = "title-module--wrapper__bloodorange--bc11f";
export var wrapper__chartruse = "title-module--wrapper__chartruse--8f1e0";
export var wrapper__cobalt = "title-module--wrapper__cobalt--a9f05";
export var wrapper__emerald = "title-module--wrapper__emerald--46756";
export var wrapper__paper = "title-module--wrapper__paper--3825e";
export var wrapper__pink = "title-module--wrapper__pink--b49fe";
export var wrapper__sky = "title-module--wrapper__sky--1c554";
export var wrapper__white = "title-module--wrapper__white--700e1";